<template>
  <v-data-table
    ref="tableRef"
    v-bind="$attrs"
    :row-props="rowProps"
    @update:page="handlePageUpdate"
    @update:items-per-page="handleItemsPerPageUpdate"
  >
    <template v-for="(_, name) in $slots" :key="name" #[name]="slotData">
      <slot :name="name" v-bind="slotData || {}" />
    </template>

    <template v-if="!$slots['no-data']" #no-data>
      <div class="sw-table-empty">
        <v-icon size="40" class="sw-table-empty__icon">
          mdi-table-off
        </v-icon>
        <p class="sw-table-empty__text">{{ emptyText }}</p>
      </div>
    </template>

    <template
      v-for="col in autoStatusColumns"
      :key="`sw-auto-status-${col}`"
      #[`item.${col}`]="{ item }"
    >
      <StatusChip :value="getItemStatusValue(item, col)" />
    </template>
  </v-data-table>
</template>

<script>
import { getItemStatusValue, isStatusColumn } from "@/utils/statusChip.js";

export default {
  name: "SwDataTable",
  inheritAttrs: false,
  props: {
    rowProps: {
      type: [Object, Function],
      default: undefined,
    },
  },
  emits: ["update:page", "update:items-per-page"],

  watch: {
    "$attrs.items"() {
      this.scheduleScrollReset();
    },
    "$attrs.search"() {
      this.scheduleScrollReset();
    },
  },

  mounted() {
    this.scheduleScrollReset();
  },

  computed: {
    emptyText() {
      return this.$attrs["no-data-text"] || "No data available";
    },
    autoStatusColumns() {
      const headers = this.$attrs.headers;
      if (!Array.isArray(headers)) return [];

      const slotNames = new Set(Object.keys(this.$slots));

      const cols = [];

      for (const h of headers) {
        const key = h?.key ?? h?.value;
        const title = h?.title ?? h?.text ?? "";

        if (!key || typeof key !== "string") continue;
        if (slotNames.has(`item.${key}`)) continue;
        if (isStatusColumn(key) || isStatusColumn(title)) {
          cols.push(key);
        }
      }

      return cols;
    },
  },

  methods: {
    getItemStatusValue,
    scheduleScrollReset() {
      this.$nextTick(() => {
        requestAnimationFrame(() => this.resetTableScroll());
      });
    },
    resetTableScroll() {
      const root = this.$refs.tableRef?.$el;
      const wrapper = root?.querySelector?.(".v-table__wrapper");
      if (wrapper) wrapper.scrollTop = 0;
    },
    handlePageUpdate(page) {
      this.$emit("update:page", page);
      this.scheduleScrollReset();
    },
    handleItemsPerPageUpdate(count) {
      this.$emit("update:items-per-page", count);
      this.scheduleScrollReset();
    },
  },
};
</script>
